import React, { Component } from "react";
import { connect } from "react-redux";

//Actions
import * as ACTIONS from "./../../../actions/actionConstants";

//MUI
import {
  Button,
  Collapse,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListSubheader,
  Switch,
  Typography
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

//Icons
import DeleteIcon from "@material-ui/icons/Delete";
import MessageIcon from "@material-ui/icons/Message";
import PhoneIcon from "@material-ui/icons/Phone";

//MUI
const styles = theme => ({
  root: {
    maxWidth: 360
  },
  divider: { margin: "2em 1em" },
  listItem: {}
});

//Redux
function mapStateToProps(state) {
  return {
    cUID: state.user.currentUser.cUID

    //User Info
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleDeleteUser: (uUID, cUID, val) => {
      dispatch({
        type: ACTIONS.HIT_CLIENT,
        payload: {
          cUID,
          uUID,
          val
        },
        filter: "delete_user"
      });
    },
    //Advanced Form Toggle
    handleToggle: (uUID, cUID, val) => {
      dispatch({
        type: ACTIONS.HIT_CLIENT,
        payload: {
          cUID,
          uUID,
          val
        },
        filter: "toggle_user"
      });
    }
  };
}

class UsersList extends Component {
  state = {
    confirm: false,
    deleteId: null,
    open: false,
    activeID: null
  };

  handleClick = (e, a) => {
    this.setState({
      open: !this.state.open,
      activeID: a
    });
  };

  handleConfirm = (e, a, val) => {
    this.setState({
      confirm: val,
      deleteId: a
    });
  };

  handleDelete = (uUID, cUID, val) => {
    this.props.handleDeleteUser(uUID, cUID, val);
  };

  handleChange = (uUID, cUID) => e => {
    this.props.handleToggle(uUID, cUID, e.target.checked);
  };

  render() {
    const { classes, cUID, users } = this.props;

    // If no users
    if (!users) {
      return null;
    }

    const Users = Object.keys(users).map((a, i) => {
      let user = users[`${a}`];
      const { client, status, uUID } = user;
      const { email, name, notes, phone, position } = user.profile;

      //Don't show deleted users
      if (status === "deleted") {
        return null;
      }

      return (
        <div key={a}>
          <ListItem button onClick={(e, id) => this.handleClick(e, a)}>
            <ListItemText primary={name.toUpperCase()} secondary={email.toLowerCase()} />
            <ListItemSecondaryAction>
              <IconButton aria-label="Send" href={"mailto:" + email} target="_top">
                <MessageIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Collapse in={this.state.open && this.state.activeID === a} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* Position if exists */}
              {position ? (
                <ListItem className={classes.listItem} dense={true}>
                  <ListItemText inset primary="position" />
                  <ListItemSecondaryAction>{position.toLowerCase()}</ListItemSecondaryAction>
                </ListItem>
              ) : null}

              {/* Phone if exists */}
              {phone ? (
                <ListItem className={classes.listItem} dense={true}>
                  <ListItemText inset primary="phone" secondary={phone} />
                  <IconButton aria-label="Phone" href={"tel:" + phone} target="_top">
                    <PhoneIcon />
                  </IconButton>
                </ListItem>
              ) : null}

              {/* Change active status */}
              <ListItem className={classes.listItem} dense={true}>
                <ListItemText inset primary={user.status} />
                <ListItemSecondaryAction>
                  <Switch checked={user.status === "active"} onChange={this.handleChange(a, cUID)} aria-label="UserSwitch" />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Delete User */}

              {this.state.confirm && this.state.deleteId === a ? (
                <ListItem className={classes.listItem} dense={true}>
                  <ListItemText
                    inset
                    primary="reject delete"
                    secondary="do not remove"
                    onClick={(e, id, val) => this.handleConfirm(e, null, false)}
                  />
                  <Button color="secondary" onClick={() => this.handleDelete(uUID, client, true)}>
                    Delete
                  </Button>
                </ListItem>
              ) : (
                <ListItem className={classes.listItem} dense={true}>
                  <ListItemText inset primary="delete" secondary="remove user" />
                  <IconButton aria-label="Delete" onClick={(e, id, val) => this.handleConfirm(e, a, true)}>
                    <DeleteIcon />
                  </IconButton>
                </ListItem>
              )}

              {/* Notes if exists */}
              {notes ? (
                <ListItem className={classes.listItem} dense={true}>
                  <Typography>{notes.toLowerCase()}</Typography>
                </ListItem>
              ) : null}
              <Divider className={classes.divider} />
            </List>
          </Collapse>
        </div>
      );
    });

    return (
      <div className={classes.root}>
        <List component="nav" subheader={<ListSubheader component="div">users</ListSubheader>}>
          {Users}
        </List>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UsersList));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/account_tabs/UsersList.js